// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import SheetDialog, { type SheetDialogProps } from "@/common/components/atom/modal/sheetDialog";
import useResponsive from "@/common/hooks/useResponsive";
import {
  PlasmicPaziresh24Modal,
  DefaultPaziresh24ModalProps
} from "./plasmic/paziresh_24_design_system/PlasmicPaziresh24Modal";

// Your component props start with props for variants and slots you defined
// in Plasmic, but you can add more here, like event handlers that you can
// attach to named nodes in your component.
//
// If you don't want to expose certain variants or slots as a prop, you can use
// Omit to hide them:
//
// interface Paziresh24ModalProps extends Omit<DefaultPaziresh24ModalProps, "hideProps1"|"hideProp2"> {
//   // etc.
// }
//
// You can also stop extending from DefaultPaziresh24ModalProps altogether and have
// total control over the props for your component.
export interface Paziresh24ModalProps extends DefaultPaziresh24ModalProps {}

function Paziresh24Modal(props: Paziresh24ModalProps) {
  // Use PlasmicPaziresh24Modal to render this component as it was
  // designed in Plasmic, by activating the appropriate variants,
  // attaching the appropriate event handlers, etc.  You
  // can also install whatever React hooks you need here to manage state or
  // fetch data.
  //
  // Props you can pass into PlasmicPaziresh24Modal are:
  // 1. Variants you want to activate,
  // 2. Contents for slots you want to fill,
  // 3. Overrides for any named node in the component to attach behavior and data,
  // 4. Props to set on the root node.
  //
  // By default, we are just piping all Paziresh24ModalProps here, but feel free
  // to do whatever works for you.

  // Mobile: the site-wide bottom sheet (browser Back, `?sheets=` in the URL). Desktop: unchanged.
  const { isMobile } = useResponsive();
  if (isMobile) return <SheetDialog {...(props as SheetDialogProps)} />;
  return <PlasmicPaziresh24Modal {...props} />;
}

export default Paziresh24Modal;
